import { render, staticRenderFns } from "./the-modals.vue?vue&type=template&id=5bb16cf3"
import script from "./the-modals.vue?vue&type=script&lang=js"
export * from "./the-modals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports